import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-current-members',
  templateUrl: './current-members.component.html',
  styleUrls: ['./current-members.component.scss']
})
export class CurrentMembersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
